module.exports = __webpack_public_path__ + "img/japan-colorectal-cancer-female.48d6be4b.png";